import { styled } from 'styled-components';
export const AlertBannerIconContainer = styled.div.withConfig({
  displayName: "AlertBannerIconContainer",
  componentId: "asurion-ui-react__sc-jxky18-0"
})(["margin-left:1rem;margin-top:1rem;"]);